import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { GraduationCap, Banknote } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { fmtAZN } from "@/lib/api";

const ModeCard = ({ id, title, desc, amount, Icon, onClick, accent }) => (
  <motion.button whileHover={{ y: -6, rotateX: 4 }} style={{ transformPerspective: 900 }} onClick={onClick}
    className="text-left rounded-2xl sm:rounded-3xl border bg-[#111]/90 backdrop-blur-xl p-4 sm:p-8 transition-colors hover:bg-[#161616] active:scale-[0.98]"
    data-testid={`mode-${id}-btn`} >
    <div className="flex items-center justify-between mb-3 sm:mb-6">
      <div className="p-2 sm:p-3 rounded-2xl" style={{ background: `${accent}22`, color: accent }}><Icon size={24} /></div>
      <span className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-zinc-500 hidden sm:inline">Balans</span>
    </div>
    <h3 className="font-display font-bold text-lg sm:text-2xl" style={{ color: accent }}>{title}</h3>
    <p className="text-zinc-400 text-xs sm:text-sm mt-1 sm:mt-2 sm:min-h-[40px] hidden sm:block">{desc}</p>
    <p className="font-display font-black text-xl sm:text-3xl mt-3 sm:mt-6" data-testid={`mode-${id}-balance`}>{fmtAZN(amount)}</p>
  </motion.button>
);

export const ModeSelect = ({ game, onSelect }) => {
  const { user } = useAuth();
  return (
    <div className="max-w-4xl mx-auto" data-testid="mode-select">
      <div className="flex items-center gap-4 sm:gap-5 mb-5 sm:mb-10">
        <img src={game.image} alt={game.name} className="w-16 h-16 sm:w-28 sm:h-28 rounded-2xl object-cover border border-[#D4AF37]/40" />
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37]">Rejim seçin</p>
          <h1 className="font-display font-black text-2xl sm:text-5xl tracking-tighter mt-1">{game.name}</h1>
          <p className="text-zinc-400 text-sm sm:text-base mt-1">{game.tagline}</p>
        </div>
      </div>
      {user === null ? null : !user ? (
        <div className="rounded-3xl border border-white/10 bg-[#111]/90 p-8 text-center space-y-5" data-testid="mode-login-required">
          <p className="text-zinc-300">Demo və ya real oynamaq üçün hesabınıza daxil olun.</p>
          <div className="flex justify-center gap-3">
            <Link to="/login" className="btn-ghost rounded-full px-6 py-3" data-testid="mode-login-btn">Giriş</Link>
            <Link to="/register" className="btn-gold rounded-full px-6 py-3 font-semibold" data-testid="mode-register-btn">Qeydiyyat</Link>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:gap-5">
          <ModeCard id="demo" title="Demo oyun" desc="Pulsuz virtual balansla risksiz məşq edin." amount={user.demo_balance} Icon={GraduationCap} accent="#38bdf8" onClick={() => onSelect("demo")} />
          <ModeCard id="real" title="Real oyun" desc="Real balansla oynayın, real qazanın." amount={user.balance} Icon={Banknote} accent="#FFD700" onClick={() => onSelect("real")} />
        </div>
      )}
    </div>
  );
};
